import React from 'react';
import Carousel from '../Carousel';

type ArticleCarouselProps = {
  styles: React.CSSProperties;
  images: {
    url: string;
  }[];
};

// TODO (VS): Find a test case for this component
const ArticleCarousel: React.FC<ArticleCarouselProps> = ({
  images,
  styles,
}) => {
  return (
    <div
      className="relative w-full h-full page-builder-carousel"
      data-pb-type="Carousel"
    >
      <Carousel
        emblaOptions={{
          loop: true,
        }}
        fullWidthSlides={true}
      >
        {images?.map((image, index) => (
          <div key={index} className="flex items-center relative h-full">
            <img
              className="w-full h-full max-h-[80vh]"
              src={image.url}
              alt="image"
              style={{ ...styles, objectFit: 'contain', margin: '0 auto' }}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default ArticleCarousel;
